import { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

// Clave usada para persistir el código de referido entre /r/:code y el registro.
export const REFERRAL_STORAGE_KEY = 'yp_referral_code';

// El código vive sólo en la pestaña donde se abrió el link (sessionStorage):
// sobrevive a navegar dentro del sitio antes de registrarse, pero se va al
// cerrarla. Antes se guardaba en localStorage sin vencimiento, y cualquier
// registro posterior en ese navegador —aunque entrara por la página normal—
// quedaba atribuido a la última referidora cuyo link se había abierto.
export const getReferralCode = () => {
    try { return sessionStorage.getItem(REFERRAL_STORAGE_KEY); } catch (e) { return null; }
};

export const clearReferralCode = () => {
    try { sessionStorage.removeItem(REFERRAL_STORAGE_KEY); } catch (e) { /* noop */ }
};

// Limpia el código que haya quedado en localStorage con la versión anterior.
try { localStorage.removeItem(REFERRAL_STORAGE_KEY); } catch (e) { /* noop */ }

// Rutas públicas /:code/register y /r/:code — guardan el código de referido y
// mandan directo al registro de modelo (los referidos son para invitar modelos),
// igual que /registermodel: sin el modal de "¿cliente o modelo?".
function ReferralCapture() {
    const { code } = useParams();
    const history = useHistory();

    useEffect(() => {
        if (code) {
            try {
                sessionStorage.setItem(REFERRAL_STORAGE_KEY, code);
            } catch (e) {
                // Si sessionStorage no está disponible, seguimos sin persistir.
            }
        }
        history.replace('/registermodel');
    }, [code, history]);

    return null;
}

export default ReferralCapture;
